import { useState } from "react";

import { Box, Wrap, WrapItem } from "@chakra-ui/react";
import { isEmpty } from "lodash";

import { Tag } from "@/components/display";
import {
  Editable,
  EditableField,
  EditablePreview,
  Option,
  Select,
  useIsDirty,
} from "@/components/form";
import { asOptions, useSeniorities } from "@/services/hooks/typeahead";

import { EditableFieldLabel } from "./editable-field-label";
import { EditableFieldProps } from "./types";

export const SenioritiesEditableField = ({
  defaultValue,
  isReadOnly = false,
  onChange,
  onSave,
  onCancel,
}: EditableFieldProps<Option[]>) => {
  const [nextValue, setNextValue] = useState(defaultValue);

  const isDirty = useIsDirty(
    defaultValue?.map((x) => x.value).sort(),
    nextValue?.map((x) => x.value).sort()
  );

  const [searchQuery, setSearchQuery] = useState("");

  const { data: seniorities = [], isLoading: isLoadingSeniorities } =
    useSeniorities({
      select: asOptions,
    });

  return (
    <Box w="full">
      <EditableFieldLabel isDirty={isDirty}>Seniority level</EditableFieldLabel>

      <Editable
        label="Seniority level"
        isReadOnly={isReadOnly}
        hasValue={!isEmpty(defaultValue)}
        onSave={async () => {
          await onSave?.(nextValue);
        }}
        onCancel={() => {
          setNextValue(defaultValue);
          onCancel?.();
        }}
      >
        <EditablePreview>
          <Wrap spacing={1}>
            {defaultValue?.map((item) => (
              <WrapItem key={item.value}>
                <Tag>{item.label}</Tag>
              </WrapItem>
            ))}
          </Wrap>
        </EditablePreview>

        <EditableField>
          <Select
            defaultValue={defaultValue}
            value={nextValue}
            options={seniorities}
            inputValue={searchQuery}
            placeholder="Search for seniority levels..."
            tagVariant="outline"
            isMulti
            isLoading={isLoadingSeniorities}
            onSearchQueryChange={(value) => {
              setSearchQuery(value);
            }}
            onChange={(value) => {
              setNextValue(value);
              onChange?.(value);
            }}
          />
        </EditableField>
      </Editable>
    </Box>
  );
};
